require('./contractPayrollLoanBiggerImport.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @core
const { FormattedText } = require('core/i18n').i18n;

// @utilities
const { decimalsLength, getFormattedString } = require('utilities/currencyHelper');

// @components
const ContractLoanSliders = require('../../contractLoanSliders/contractLoanSliders');

class ContractPayrollLoanBiggerImport extends React.Component {
    constructor(props) {
        super(props);

        this.state = { show: false };

        this.handleSlide = this.handleSlide.bind(this);
    }

    buildIcon() {
        const { show } = this.state;
        let iconCss = 'icon contract-payroll-loan-bigger-import__icon icon-accordion-';
        iconCss += show ? 'cerrar' : 'abrir';

        return (
            <i className={iconCss} />
        );
    }

    buildOffer() {
        const { immContractPayrollLoan } = this.props;
        const collective = immContractPayrollLoan.get('isCollective');
        const maxAmountCollective = immContractPayrollLoan.getIn(['collectiveInformation', 0, 'maxAmount']);
        const offer = collective && immContractPayrollLoan.get('maxAmount') > maxAmountCollective ? maxAmountCollective : immContractPayrollLoan.get('maxAmount');
        const decimalsLengthLoanImport = decimalsLength(offer);

        return [getFormattedString({
            amount: offer,
            currency: immContractPayrollLoan.get('currency'),
            decimalsLength: decimalsLengthLoanImport
        })];
    }

    buildSliders() {
        const { getInstallment, immContractPayrollLoan,
            customValues, setLoanAmount, setLoanTerm, getMinTerm } = this.props;
        const { show } = this.state;
        const subtitle = this.buildSubtitle();

        return show ? (
            <div className="contract-payroll-loan-bigger-import__sliders">
                {subtitle}
                <ContractLoanSliders
                    customValues={customValues}
                    termTitle="contractPayrollLoanBiggerImport-term"
                    getInstallment={getInstallment}
                    immContractLoan={immContractPayrollLoan}
                    setLoanAmount={setLoanAmount}
                    setLoanTerm={setLoanTerm}
                    getMinTerm={getMinTerm}
                    showTooltip
                />
            </div>
        ) : null;
    }

    buildSubtitle() {
        const { showSubtitle } = this.props;

        return showSubtitle ? (
            <p>
                <FormattedText value="contractPayrollLoanBiggerImport-message" />
            </p>
        ) : null;
    }

    buildTitle() {
        const { showTitle } = this.props;
        const offer = this.buildOffer();

        return showTitle ? (
            <p className="contract-payroll-loan-bigger-import__amount">
                <FormattedText value="contractPayrollLoanBiggerImport-title" injectedStrings={offer} />
            </p>
        ) : null;
    }

    handleSlide() {
        this.setState({ show: !this.state.show });
    }

    render() {
        const { showBox } = this.props;
        const sliders = this.buildSliders();
        const icon = this.buildIcon();
        const title = this.buildTitle();

        const boxCss = classNames(
            {
                'contract-payroll-loan-bigger-import__box': showBox
            });

        return (
            <section className="contract-payroll-loan-bigger-import">
                {title}
                <div className={boxCss}>
                    <div className="contract-payroll-loan-bigger-import__title" onClick={this.handleSlide}>
                        <div className="contract-payroll-loan-bigger-import__ajust">
                            <FormattedText value="contractPayrollLoanBiggerImport-ajust" />
                        </div>
                        {icon}
                    </div>
                    {sliders}
                </div>
            </section>
        );
    }
}

ContractPayrollLoanBiggerImport.propTypes = {
    customValues: PropTypes.object,
    getInstallment: PropTypes.func.isRequired,
    getMinTerm: PropTypes.func,
    immContractPayrollLoan: PropTypes.object.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    showBox: PropTypes.bool,
    showTitle: PropTypes.bool,
    showSubtitle: PropTypes.bool
};

module.exports = ContractPayrollLoanBiggerImport;
